import React from 'react';
import { Button } from '../../../Components/MUIs';
import Canvas from '../../../Components/Canvas/Canvas';

export default function M_TRA_SIGN({
  sessionCd,
  signUserId = '',
  signatureCanvas,
  signInputs,
  setSignInputs,
  signUpload,
  onConfirm,
  onClear,
  confirmDisabled = false,
}) {
  return (
    <div className="flex h-full flex-col bg-slate-50">
      <div className="flex-1 overflow-y-auto p-4">
        <div className="rounded-2xl border border-slate-100 bg-white p-4 shadow-sm">
          <p className="text-base font-bold text-slate-900">
            안전보건교육 참석 서명
          </p>
          <p className="mt-1 text-sm text-slate-500">
            QR 스캔 정보: {sessionCd || '-'}
          </p>
          <p className="mt-3 rounded-lg bg-slate-50 p-3 text-xs leading-relaxed text-slate-600">
            교육 참석 확인을 위해 서명해 주세요. 서명 후 확인 버튼을 누르면
            참석처리가 완료됩니다.
          </p>
        </div>

        <div className="mt-4 rounded-2xl border border-slate-100 bg-white p-4 shadow-sm">
          <Canvas
            signatureCanvas={signatureCanvas}
            userId=""
            imageUrl={signInputs.mapUrl}
            disabled={false}
            onEnd={() => {
              if (!signatureCanvas.current) return;
              signUpload?.clearFiles?.();
              const signatureDataUrl = signatureCanvas.current.toDataURL();
              const dataURL = signatureCanvas.current.toDataURL('image/png');
              const decodedData = atob(dataURL.split(',')[1]);
              const byteNumbers = new Array(decodedData.length);

              for (let i = 0; i < decodedData.length; i++) {
                byteNumbers[i] = decodedData.charCodeAt(i);
              }

              const byteArray = new Uint8Array(byteNumbers);
              const blob = new Blob([byteArray], {
                type: 'image/png',
              });
              const rawId = String(signUserId ?? '').trim();
              const safeUserId =
                rawId.replace(/[\\/:*?"<>|]/g, '_').slice(0, 120) || 'unknown';
              const file = new File([blob], `mobile_sign_${safeUserId}.png`, {
                type: 'image/png',
              });

              setSignInputs((prev) => ({
                ...prev,
                mapUrl: signatureDataUrl,
                mapFiles: file,
              }));
              signUpload?.FileChange?.({
                target: { files: [file] },
              });
            }}
          />

          <div className="mt-3">
            <Button
              variant="outlined"
              className="h-9 w-full rounded-full"
              name="서명 다시하기"
              onClick={onClear}
            />
          </div>
        </div>
      </div>

      <div className="border-t border-slate-200 bg-white p-4 pb-[max(1rem,env(safe-area-inset-bottom))]">
        <Button
          className="h-11 w-full rounded-full bg-[#2EBD36] text-white"
          name="확인"
          onClick={onConfirm}
          disabled={confirmDisabled}
        />
      </div>
    </div>
  );
}
